/**
 * --------------------------------------------------
 * @param {number} offerId
 *
 * @param {object?} extraParams
 * @param {string?} extraParams.reason
 * @param {boolean?} extraParams.pay_proportionately
 * @param {string?} extraParams.end_time
 * @param {number?} extraParams.value
 *
 * @param {object?} faceScan
 * @param {binary} faceScan.image
 * @param {object} faceScan.location
 * @param {number} faceScan.location.latitude
 * @param {number} faceScan.location.longitude
 * @example
 * faceScanMiddleware({
 *  offerId: 468,
 *  faceScan: { image: null, location: null },
 *  extraParams: { reason: "teste", pay_proportionately: false }
 * })
 */
export const faceScanMiddleware = ({ offerId, faceScan, extraParams }) => {
  let body = {
    offer: offerId,
    ...extraParams,
  };

  let headers = {};

  if (!!faceScan) {
    const { image, location } = faceScan;

    headers = {
      "Content-Type": "multipart/form-data",
    };

    const formData = new FormData();
    formData.append("offer", offerId);
    formData.append("face_scan_data.image_data", image, "image.jpeg");

    formData.append(
      "face_scan_data.point",
      JSON.stringify({
        latitude: location?.latitude,
        longitude: location?.longitude,
      })
    );

    if (extraParams) {
      Object.keys(extraParams).forEach((key) => {
        formData.append(key, extraParams[key]);
      });
    }

    body = formData;
  }

  return { body, headers };
};
